import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
  isAsyncFailure,
} from "async-ops";
import { cloneDeep, cloneDeepWith, isEqual } from "lodash";
import {
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../../../common_components/mdae-framework";
import { GET_AUDIT_PROCESS_TEMPLATE_GROUP_LIST } from "../services/get-audit-group-list";
import { GET_PROCESS_TEMPLATE_LINKED_DATA } from "../services/get-process-template-linked-data";
import { GET_PROCESS_TEMPLATE_LIST } from "../services/get-process-template-list";
import {
  GET_AUDIT_STATUS_LIST,
  GET_CASE_STATUS_LIST,
  GET_TASK_STATUS_LIST,
} from "../services/get-status-list";
import { GET_REFERENCE_DATA } from "../services/get-reference-data";
import { PROCESS_TEMPLATE_TASK_TRIGGERS } from "../task-card";
import { format } from "date-fns";
import Guid from "devextreme/core/guid";
import { GET_AUDIT_TYPE } from "../services/get-audit-type";
import { ATTACHED_LEVEL_NAME } from "../../../external-audit/constants";
export const TOGGLE_PROCESS_TEMPLATE_LIST_ACTION_POPOVER =
  "TOGGLE_PROCESS_TEMPLATE_LIST_ACTION_POPOVER";
export const TOGGLE_ADD_PROCESS_TEMPLATE_POPUP =
  "TOGGLE_ADD_PROCESS_TEMPLATE_POPUP";
export const SET_PROCESS_TEMPLATE_FORM_DATA = "SET_PROCESS_TEMPLATE_FORM_DATA";
export const SET_PROCESS_TEMPLATE_SELECTED_INDEX =
  "SET_PROCESS_TEMPLATE_SELECTED_INDEX";
export const RESET_PROCESS_TEMPLATE_POPUP_VALIDATION =
  "RESET_PROCESS_TEMPLATE_POPUP_VALIDATION";
export const TOGGLE_PROCESS_TEMPLATE_ERROR_POPUP =
  "TOGGLE_PROCESS_TEMPLATE_ERROR_POPUP";
export const TOGGLE_PROCESS_TEMPLATE_WARNING_POPUP =
  "TOGGLE_PROCESS_TEMPLATE_WARNING_POPUP";
export const TOGGLE_PROCESS_ROUND_HEADER_DISPLAY =
  "TOGGLE_PROCESS_ROUND_HEADER_DISPLAY";
export const SET_PROCESS_TEMPLATE_DATAGRID_FILTER =
  "SET_PROCESS_TEMPLATE_DATAGRID_FILTER";
export const SET_PROCESS_TEMPLATE_ROUND_LIST =
  "SET_PROCESS_TEMPLATE_ROUND_LIST";
export const REMOVE_PROCESS_TEMPLATE_ROUND = "REMOVE_PROCESS_TEMPLATE_ROUND";
export const SET_DEFAULT_PROCESS_TEMPLATE_ROUND_LIST =
  "SET_DEFAULT_PROCESS_TEMPLATE_ROUND_LIST";
export const UPDATE_PROCESS_TEMPLATE_ROUND_LIST =
  "UPDATE_PROCESS_TEMPLATE_ROUND_LIST";
export const TOGGLE_ADD_TASK_POPUP = "TOGGLE_ADD_NEW_TASK_POPUP";
export const SET_TASK_FORM_DATA = "SET_TASK_FORM_DATA";
export const SET_TASK_TEMPLATE_DATASOURCE = "SET_TASK_TEMPLATE_DATASOURCE";
export const SET_TRIGGER_LIST = "SET_TRIGGER_LIST";
export const ADD_PROCESS_TEPLATE_ROUND_TASK = "ADD_PROCESS_TEPLATE_ROUND_TASK";
export const SET_PREVIOUS_REF_TASK_DATA = "SET_PREVIOUS_REF_TASK_DATA";
export const SET_TASK_LIST_ACCORDION_CONFIG = "SET_TASK_LIST_ACCORDION_CONFIG";
export const RESET_DELETED_ID_VARIABLES = "RESET_DELETED_ID_VARIABLES";
export const SET_IS_TASK_TEMPLATE_ADDED = "SET_IS_TASK_TEMPLATE_ADDED";
export const TOGGLE_ROUND_TASK_TYPE_VALUE = "TOGGLE_ROUND_TASK_TYPE_VALUE";
export const SET_INITIAL_ROUND_REQUESTOR = "SET_INITIAL_ROUND_REQUESTOR";
export const RESET_ADD_TASK_TRIGGER_POPUP_VALIDATION =
  "RESET_ADD_TASK_TRIGGER_POPUP_VALIDATION";
export const SET_INITIAL_PROCESS_FORM_DATA = "SET_INITIAL_PROCESS_FORM_DATA";
export const REMOVE_TASK_TRIGGER = "REMOVE_TASK_TRIGGER";
export const SET_TASK_TRIGGER_POPUP_MODE = "SET_TASK_TRIGGER_POPUP_MODE";
export const SET_ACCORDIAN_SEQUENCE_NO = "SET_ACCORDIAN_SEQUENCE_NO";
export const TOGGLE_ADD_TASK_MODE = "TOGGLE_ADD_TASK_MODE";
export const UPDATE_PROCESS_TEPLATE_ROUND_TASK =
  "UPDATE_PROCESS_TEPLATE_ROUND_TASK";
export const SET_PROCESS_TEMP_ROUND_DATA = "SET_PROCESS_TEMP_ROUND_DATA";
export const COPY_PROCESS_TEMPLATE_ROUND = "COPY_PROCESS_TEMPLATE_ROUND";
export const ADD_NEW_PROCESS_TEMPLATE_ROUND = "ADD_NEW_PROCESS_TEMPLATE_ROUND";
export const SET_PROCESS_TEMPLATE_LINKED_DATA =
  "SET_PROCESS_TEMPLATE_LINKED_DATA";
export const SET_PREVIOUS_CONTENT_TYPE_LIST_FOR_PROCESS_TEMPLATE =
  "SET_PREVIOUS_CONTENT_TYPE_LIST_FOR_PROCESS_TEMPLATE";
export const FILTER_ASSIGNED_TO_USER_TYPES_BY_WORKFLOW =
  "FILTER_ASSIGNED_TO_USER_TYPES_BY_WORKFLOW";
export const MDAUDIT_TRANSFER = "MDAUDIT_TRANSFER";
export const SET_TRIGGER_AS_UPDATED_AFTER_TRASFER =
  "SET_TRIGGER_AS_UPDATED_AFTER_TRASFER";
export const SET_REMIT_SELECTION =
  "SET_REMIT_SELECTION";
export const REORDER_ROUND_TASK_TRIGGER_LIST = "REORDER_ROUND_TASK_TRIGGER_LIST";
export const ADD_ROUND_DOCUMENTS = "ADD_ROUND_DOCUMENTS";
export const REMOVE_ROUND_DOCUMENT = "REMOVE_ROUND_DOCUMENT";
export const UPDATE_ROUND_DOCUMENT = "UPDATE_ROUND_DOCUMENT";
export const TRACK_EDITED_ROUND_DOCUMENT = "TRACK_EDITED_ROUND_DOCUMENT";
export const TASK_TRIGGER_POPUP_MODE = {
  EDIT: "EDIT",
  ADD: "ADD",
};
export const rllDataSource=[
  {id: 1, name: 'Yes'},
  {id: 0, name: 'No'}
];
export const TOGGLE_ROUND_TASK_TYPE = {
  EA_ROUND_TASK: "EA_ROUND_TASK",
  PROCESS_TEMPLATE_ROUND_TASK: "PROCESS_TEMPLATE_ROUND_TASK",
};
export const REMIT_RADIO_CONSTANT_LABEL = {
  isRemitAllPayersEnabled: "isRemitAllPayersEnabled",
  isAtRiskPayerEnabled:"isAtRiskPayerEnabled"
}
export const REMIT_SELECTION_OPTION = 
  [{ value: "isRemitAllPayersEnabled",
      text: "All Payers",
    },
    {
      value: "isAtRiskPayerEnabled",
      text: "Selected At Risk $",
    }];
export const processTemplateFormData = {
  name: "",
  alias: null,
  eaRequesterId: null,
  claimTypeCd: "",
  organizationType: "",
  prepaymentReviewInd: false,
  description: "",
  selectedAuditGroupIds: [],
  effectiveDate: new Date(),
  termDate: null,
  updatedBy: "",
  updateDate: null,
  curatedInd: false,
  selectedRequiredFieldIds: [],
  selectedRequiredCaseFieldIds: [],
  eaProcessTemplateId: 0,
  isCaseAlertsEnabled: true,
  processTemplateCaseAlertsAssociation: {
    isRemitEnabled: false,
    isRemitAllPayersEnabled: false,
    isAtRiskPayerEnabled: false,
    isEsmdSubmissionErrorsEnabled: true,
    selectedPayerType: null,
  },
  isRoundLineLevelTrackingEnabled: 1,
  isTaskTriggersReordered:false
};
export const taskFormData = {
  level: "All",
  refTaskId: null,
  triggerId: null,
  previousRefTaskId: null,
  previousTaskStatusId: null,
  caseStatusId: null,
  caseOutcomeIds: null,
  auditStatusId: null,
  dueAfter: null,
  dueInterval: null,
  assignedToUserType: "PM",
  assignedToUserId: null,
  uniqueProcessTemplateTaskTriggerId: "",
};
export const initialProcessTemplateLinkedData = {
  attachedExternalAudits: [],
};
const initialState = {
  isLoading: false,
  hasAllAuditGroupAccess: false,
  processTemplateList: [],
  currentUserId: 0,
  auditGroupDataSourceList: [],
  claimTypeList: [],
  claimTypeEnums: [],
  requesterList: [],
  contentTypeList: [],
  organizationTypeList: [],
  processTemplateFormData: processTemplateFormData,
  processTemplateLinkedData: initialProcessTemplateLinkedData,
  requiredFieldList: [],
  requiredCaseFieldList: [],
  processTemplateRoundList: [
    {
      eaProcessTemplateRoundId: 0,
      eaProcessTemplateRoundName: "Initial Submission",
      eaProcessTemplateId: 0,
      requesterId: 0,
      sequenceNo: 1,
      totalDays: 0,
      isEsmdRequester: false,
      eaContentTypeId: null,
      isTextBoxWidgetVisible: false,
      processTemplateRoundTaskTrigger: [],
      processTemplateRoundTaskTriggerList: [],
      processTemplateRoundDocumentList: [],
      isContentTypeValid: true,
      isRequesterReviewContractorValid: true,
    },
  ],
  levelList: [],
  triggerList: [],
  originalTriggerList: [],
  refTaskList: [],
  originalRefTaskList: [],
  taskFormData: taskFormData,
  auditStatusList: [],
  caseStatusList: [],
  taskStatusList: [],
  caseRoundOutcomesList: [],
  taskCategoryTypeList: [],
  previousRefTaskList: [],
  taskListAccordionConfig: {},
  deletedRoundIds: [],
  deletedTaskTriggerIds: [],
  deletedRoundDocumentIds: [],
  editedRoundDocuments: [],
  isNewTaskTemplateAdded: false,
  isTasktriggerFormDataValid: true,
  previousContentTypeList: [],
  accordionNo: -1,
  updatedTaskTriggers: [],
  eaAuditTypes: [],

};

export default (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      //get external audit process template list
      if (isAsyncOperation(GET_PROCESS_TEMPLATE_LIST)(action)) {
        return { ...state, processTemplateList: [], currentUserId: 0 };
      }
      if (isAsyncComplete(GET_PROCESS_TEMPLATE_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          processTemplateList: response.processTemplateList,
          currentUserId: response.currentUserId,
          loading: false,
          hasAllAuditGroupAccess: response.hasAllAuditGroupAccess,
        };
      }
      if (isAsyncFailure(GET_PROCESS_TEMPLATE_LIST)(action)) {
        return { ...state, loading: false, error: action.error };
      }
      //get audit group list
      if (isAsyncOperation(GET_AUDIT_PROCESS_TEMPLATE_GROUP_LIST)(action)) {
        return {
          ...state,
          auditGroupDataSourceList: [],
        };
      }
      if (isAsyncComplete(GET_AUDIT_PROCESS_TEMPLATE_GROUP_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          auditGroupDataSourceList: response?.list,
        };
      }
      if (isAsyncFailure(GET_AUDIT_PROCESS_TEMPLATE_GROUP_LIST)(action)) {
        return { ...state, loading: false, error: action.error };
      }
      //Status Lists
      if (isAsyncOperation(GET_AUDIT_STATUS_LIST)(action)) {
        return { ...state, auditStatusList: [] };
      }
      if (isAsyncOperation(GET_CASE_STATUS_LIST)(action)) {
        return { ...state, caseStatusList: [] };
      }
      if (isAsyncOperation(GET_TASK_STATUS_LIST)(action)) {
        return { ...state, taskStatusList: [] };
      }
      if (isAsyncComplete(GET_AUDIT_STATUS_LIST)(action)) {
        const response = action.response;
        var auditStatusForTrigger = response?.filter(
          (x) => x.statusType != "New"
        );
        return {
          ...state,
          auditStatusList: response,
          auditStatusForTrigger: auditStatusForTrigger,
        };
      }
      if (isAsyncComplete(GET_CASE_STATUS_LIST)(action)) {
        const response = action.response;
        var caseStatusForTrigger = response?.filter(
          (x) => x.statusType != "New"
        );
        return {
          ...state,
          caseStatusList: response,
          caseStatusForTrigger: caseStatusForTrigger,
        };
      }
      if (isAsyncComplete(GET_TASK_STATUS_LIST)(action)) {
        const response = action.response;
        var taskStatusForTrigger = response?.filter(
          (x) => x.statusType != "New"
        );
        return {
          ...state,
          taskStatusList: response,
          taskStatusForTrigger: taskStatusForTrigger,
        };
      }
      if (isAsyncFailure(GET_AUDIT_STATUS_LIST)(action)) {
        return { ...state, loading: false, error: action.error };
      }
      if (isAsyncFailure(GET_CASE_STATUS_LIST)(action)) {
        return { ...state, loading: false, error: action.error };
      }
      if (isAsyncFailure(GET_TASK_STATUS_LIST)(action)) {
        return { ...state, loading: false, error: action.error };
      }

      //get reference data
      if (isAsyncOperation(GET_REFERENCE_DATA)(action)) {
        return {
          ...state,
          claimTypeList: [],
          claimTypeEnums: [],
          requesterList: [],
          organizationTypeList: [],
          requiredFieldList: [],
          requiredCaseFieldList: [],
          originalTriggerList: [],
          levelList: [],
          triggerList: [],
          refTaskList: [],
          defaultRefTaskList: [],
          caseRoundOutcomesList: [],
          taskCategoryTypeList: [],
          contentTypeList: [],
          reviewContractorContentTypeList: [],
          reviewContractorList: [],
        };
      }
      if (isAsyncComplete(GET_REFERENCE_DATA)(action)) {
        const response = action.response;
        var refTaskList = response?.refTaskList.filter(
          (x) => x.moduleTypeValue == "EAW" && x.levelValue != "AE"
        );
        var originalRefTaskList = cloneDeep(refTaskList);
        var originalTriggerList = cloneDeep(response?.triggerList);
        var caseRoundOutcomesList = response?.caseRoundOutcomesList.filter(
          (x) => x.outcomeArea === "CRO" || x.outcomeArea === "PRCRO"
        );
        var newTaskTemplateAdded = refTaskList.filter(function (x) {
          var taskTemplate = state.originalRefTaskList.find(
            (y) => y.refTaskId == x.refTaskId
          );
          if (!taskTemplate) {
            return x;
          }
        });
        const retrunObj = {
          ...state,
          claimTypeList: response?.claimTypeList,
          claimTypeEnums: response?.claimTypeEnums[0],
          requesterList: response?.requesterList,
          organizationTypeList: response?.organizationTypeList,
          requiredFieldList: response?.requiredFieldList,
          requiredCaseFieldList: response?.requiredCaseFieldList,
          levelList: response?.levelList,
          triggerList: response?.triggerList,
          refTaskList: refTaskList,
          originalRefTaskList: originalRefTaskList,
          originalTriggerList: originalTriggerList,
          caseRoundOutcomesList: caseRoundOutcomesList,
          taskCategoryTypeList: response?.taskCategoryTypeList,
          contentTypeList: response?.contentTypes,
          reviewContractorContentTypeList:
            response?.reviewContractorContentTypeList,
          reviewContractorList: response?.reviewContractorList,
        };
        if (action.args && action.args[0]?.isFromTaskTemplateAdd) {
          return {
            ...retrunObj,
            isNewTaskTemplateAdded: true,
            taskFormData: {
              ...state.taskFormData,
              refTaskId:
                newTaskTemplateAdded.length > 0
                  ? newTaskTemplateAdded[0].refTaskId
                  : state.taskFormData.refTaskId,
            },
          };
        }
        return retrunObj;
      }
      if (isAsyncFailure(GET_REFERENCE_DATA)(action)) {
        return { ...state, loading: false, error: action.error };
      }
      if (isAsyncOperation(GET_PROCESS_TEMPLATE_LINKED_DATA)(action)) {
        return {
          ...state,
          processTemplateLinkedData: initialProcessTemplateLinkedData,
        };
      }
      if (isAsyncComplete(GET_PROCESS_TEMPLATE_LINKED_DATA)(action)) {
        const response = action.response;
        return {
          ...state,
          processTemplateLinkedData: response,
        };
      }
      if (isAsyncOperation(GET_AUDIT_TYPE)(action)) {
        return { ...state, eaAuditTypes: [] };
      }
      if (isAsyncComplete(GET_AUDIT_TYPE)(action)) {
        const response = action.response;
        return {
          ...state,
          eaAuditTypes: response.eaAuditTypes,
        };
      }
      return state;
    case SET_TASK_FORM_DATA:
      newState = cloneDeepWith(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        if (action.data.isTemplateChange != undefined) {
          var selectedTemplate = newState.refTaskList?.filter(
            (x) => x.refTaskId == action.data.taskFormData.refTaskId
          );
          newState.taskFormData.level = selectedTemplate[0]?.levelValue;
          newState.taskFormData.dueAfter = selectedTemplate[0]?.dueAfter;
          newState.taskFormData.dueInterval = selectedTemplate[0]?.dueInterval;
          newState.taskFormData.assignedToUserType =
            selectedTemplate[0]?.assignedToUserTypeValue;
          newState.taskFormData.assignedToUserId =
            selectedTemplate[0]?.assignedToUserId;
        } else newState = { ...newState, ...action.data };
      }
      return newState;
    case SET_IS_TASK_TEMPLATE_ADDED:
      return { ...state, isNewTaskTemplateAdded: action.data };
    case SET_PROCESS_TEMP_ROUND_DATA:
    case SET_ACCORDIAN_SEQUENCE_NO:
    case TOGGLE_ADD_TASK_MODE:
    case SET_TASK_TRIGGER_POPUP_MODE:
    case RESET_ADD_TASK_TRIGGER_POPUP_VALIDATION:
    case TOGGLE_ROUND_TASK_TYPE_VALUE:
    case TOGGLE_ADD_TASK_POPUP:
    case TOGGLE_PROCESS_TEMPLATE_WARNING_POPUP:
    case SET_PROCESS_TEMPLATE_DATAGRID_FILTER:
    case SET_PREVIOUS_CONTENT_TYPE_LIST_FOR_PROCESS_TEMPLATE:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;

    case SET_INITIAL_PROCESS_FORM_DATA:
    case SET_PROCESS_TEMPLATE_FORM_DATA:
    case RESET_PROCESS_TEMPLATE_POPUP_VALIDATION:
    case TOGGLE_ADD_PROCESS_TEMPLATE_POPUP:
    case SET_PROCESS_TEMPLATE_SELECTED_INDEX:
    case TOGGLE_PROCESS_TEMPLATE_LIST_ACTION_POPOVER:
    case TOGGLE_PROCESS_TEMPLATE_ERROR_POPUP:
    case SET_PROCESS_TEMPLATE_LINKED_DATA:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case SET_PROCESS_TEMPLATE_ROUND_LIST:
      newState = cloneDeepWith(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const processTemplateRoundItem = newState.processTemplateRoundList
          ? newState.processTemplateRoundList
          : {};
        if (action.data.processTemplateRoundItem) {
          processTemplateRoundItem.push(action.data.processTemplateRoundItem);
        }
        newState = {
          ...newState,
          processTemplateRoundList: processTemplateRoundItem,
        };
      }
      return newState;
    case COPY_PROCESS_TEMPLATE_ROUND:
      newState = cloneDeep(state);
      const processTemplateRoundList: any[] =
        newState.processTemplateRoundList || [];
      const processTemplateRoundToCopy = action.data.processTemplateRoundToCopy;
      const indexToCopyAt =
        processTemplateRoundList.findIndex(
          (x) => x.sequenceNo === action.data.sequenceNoToCopy
        ) + 1;
      processTemplateRoundList.splice(
        indexToCopyAt,
        0,
        processTemplateRoundToCopy
      );
      syncProcessTemplateRoundSequenceNumber(processTemplateRoundList);
      newState = {
        ...newState,
        processTemplateRoundList,
      };
      return newState;
    case ADD_NEW_PROCESS_TEMPLATE_ROUND:
      newState = cloneDeep(state);
      const processTemplateRoundToAdd = action.data.processTemplateRoundToAdd;
      const indexToAddAt =
        newState.processTemplateRoundList.findIndex(
          (x) => x.sequenceNo === action.data.sequenceNoToAddAfter
        ) + 1;
      newState.processTemplateRoundList.splice(
        indexToAddAt,
        0,
        processTemplateRoundToAdd
      );
      syncProcessTemplateRoundSequenceNumber(newState.processTemplateRoundList);
      newState = {
        ...newState,
        processTemplateRoundList: newState.processTemplateRoundList,
      };
      return newState;
    case ADD_PROCESS_TEPLATE_ROUND_TASK:
      newState = cloneDeepWith(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        var selectedSequenceNumber =
          action.data?.taskData?.eaProcessTemplateRoundId;
        if (action.data.taskData) {
          for (var item of newState.processTemplateRoundList) {
            if (item.sequenceNo == selectedSequenceNumber) {
              item.processTemplateRoundTaskTriggerList?.push(
                action.data.taskData
              );
            }
          }
        }
      }
      return newState;
    case REMOVE_PROCESS_TEMPLATE_ROUND:
      newState = cloneDeepWith(state);
      var updatedProcessTemplateRoundList = [];
      if (action.processTemplateRoundItem) {
        updatedProcessTemplateRoundList = newState.processTemplateRoundList.filter(
          (item) =>
            item.sequenceNo !== action.processTemplateRoundItem.sequenceNo
        );
        newState.deletedRoundIds = newState.deletedRoundIds
          ? newState.deletedRoundIds
          : [];
        if (action.processTemplateRoundItem?.eaProcessTemplateRoundId)
          newState.deletedRoundIds.push(
            action.processTemplateRoundItem?.eaProcessTemplateRoundId
          );
      }
      syncProcessTemplateRoundSequenceNumber(updatedProcessTemplateRoundList);
      return {
        ...state,
        deletedRoundIds: newState.deletedRoundIds,
        processTemplateRoundList: updatedProcessTemplateRoundList,
      };
    case SET_DEFAULT_PROCESS_TEMPLATE_ROUND_LIST:
      return {
        ...state,
        processTemplateRoundList: action.data.processTemplateRoundList,
      };
    case UPDATE_PROCESS_TEMPLATE_ROUND_LIST:
      newState = cloneDeepWith(state);
      var processTemplateRoundDataLists = formatProcessTemplateRoundList(
        action.data.processTemplateRoundList,
        action.data.selectedRowData
      );
      return {
        ...state,
        processTemplateRoundList: processTemplateRoundDataLists,
        isRoundListChanged: action.data.isRoundListChanged,
      };
    case SET_TASK_TEMPLATE_DATASOURCE:
      newState = cloneDeep(state);
      var refTaskLists = [];
      refTaskLists = cloneDeep(newState.originalRefTaskList);
      if (
        action.data.taskFormData.level == "All" ||
        !action.data.taskFormData.level
      ) {
        refTaskLists?.forEach(function (part, index, theArray) {
          refTaskLists[index].name =
            refTaskLists[index].name +
            (refTaskLists[index].levelValue == "EA" ? "(Audit)" : "(Case)");
        });
        newState.refTaskList = refTaskLists;
      } else if (action.data.taskFormData.level == "EA") {
        newState.refTaskList = refTaskLists?.filter(
          (x) => x.levelValue == "EA"
        );
      } else if (action.data.taskFormData.level == "EAC") {
        newState.refTaskList = refTaskLists?.filter(
          (x) => x.levelValue == "EAC"
        );
      }
      for (var item of newState.previousRefTaskList) {
        const found = newState.refTaskList?.find(
          (x) =>
            x.refTaskId == item.refTaskId && item.allowDuplicateInd == false
        );
        if (found) {
          newState.refTaskList = newState.refTaskList.filter(
            (x) => x.refTaskId !== found.refTaskId
          );
        }
      }
      return newState;
    case SET_TRIGGER_LIST:
      newState = cloneDeep(state);
      var list = cloneDeep(newState.originalTriggerList);
      if (
        newState.roundTaskTypeMode ==
        TOGGLE_ROUND_TASK_TYPE.PROCESS_TEMPLATE_ROUND_TASK
      ) {
        if (action.data.sequenceNo == 1) {
          newState.triggerList = list.filter((x) => x.value !== "LDD" && x.value !== "PRCRO");
        } else {
          newState.triggerList = list.filter((x) => x.value != "RS" && x.value !="ASD" && x.value != "AC");
        }
        if (
          action.data.levelValue &&
          action.data.levelValue.toUpperCase() === "EA"
        ) {
          newState.triggerList = newState.triggerList.filter(
            (x) => x.value != "CSC" && x.value != "CRO"
          );
        }
        if (
          action.data.levelValue &&
          action.data.levelValue.toUpperCase() === "EAC"
        ) {
          newState.triggerList = newState.triggerList.filter(
            (x) => x.value != "AC"
          );
        }
        if (
          action.data.previousRefTaskList?.length <= 0 ||
          (action.data.triggerType != null &&
            action.data.triggerType !=
            PROCESS_TEMPLATE_TASK_TRIGGERS.PreviousTaskStatusChange)
        ) {
          newState.triggerList = newState.triggerList.filter(
            (x) =>
              x.value != PROCESS_TEMPLATE_TASK_TRIGGERS.PreviousTaskStatusChange
          );
        }
      } else if (
        newState.roundTaskTypeMode == TOGGLE_ROUND_TASK_TYPE.EA_ROUND_TASK
      ) {
        newState.triggerList = list.filter((x) => x.value == "RS");
      }
      return newState;
    case SET_PREVIOUS_REF_TASK_DATA:
      newState = cloneDeep(state);
      var filteredList = [];
      if (action.data?.previousRefTaskList) {
        if (action.data?.currentSelectedTaskData) {
          filteredList = action.data?.previousRefTaskList.filter(
            (x) =>
              x.uniqueProcessTemplateTaskTriggerId !=
              action.data?.currentSelectedTaskData
                ?.uniqueProcessTemplateTaskTriggerId &&
              x.uniqueDependentTaskTriggerId !=
              action.data?.currentSelectedTaskData
                ?.uniqueProcessTemplateTaskTriggerId
          );
        } else {
          filteredList = action.data?.previousRefTaskList;
        }
      } else if (action.data?.taskTemplate) {
        filteredList = newState.previousRefTaskList;
        filteredList.push(action.data.taskTemplate);
      }
      return { ...state, previousRefTaskList: filteredList };
    case RESET_DELETED_ID_VARIABLES:
      newState = cloneDeep(state);
      newState.deletedRoundIds = [];
      newState.deletedTaskTriggerIds = [];
      newState.deletedRoundDocumentIds = [];
      newState.editedRoundDocuments = [];
      return newState;
    case SET_INITIAL_ROUND_REQUESTOR:
      const updatedProcessRoundList = [...state.processTemplateRoundList];
      updatedProcessRoundList.splice(0, 1, {
        ...state.processTemplateRoundList[0],
        requesterId: action.data.requesterId,
      });
      newState = {
        ...state,
        processTemplateRoundList: [...updatedProcessRoundList],
      };
      return newState;
    case REMOVE_TASK_TRIGGER:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        var selectedSequenceNumber = action.data?.eaProcessTemplateRoundId;
        if (action.data.uniqueProcessTemplateTaskTriggerId) {
          for (var item of newState.processTemplateRoundList) {
            if (
              item.eaProcessTemplateRoundId == selectedSequenceNumber ||
              item.sequenceNo == selectedSequenceNumber
            ) {
              var taskTriggerItemDeleted = item.processTemplateRoundTaskTriggerList?.filter(
                (x) =>
                  x.uniqueDependentTaskTriggerId ==
                  action.data?.uniqueProcessTemplateTaskTriggerId
              );
              if (taskTriggerItemDeleted) {
                taskTriggerItemDeleted.forEach((element) => {
                  if (element.eaProcessTemplateRoundTaskTriggerId) {
                    newState.deletedTaskTriggerIds.push(
                      element.eaProcessTemplateRoundTaskTriggerId
                    );
                  }
                });
              }
              if (action.data?.eaProcessTemplateRoundTaskTriggerId) {
                newState.deletedTaskTriggerIds.push(
                  action.data?.eaProcessTemplateRoundTaskTriggerId
                );
              }
              item.processTemplateRoundTaskTriggerList = item.processTemplateRoundTaskTriggerList?.filter(
                (x) =>
                  x.uniqueDependentTaskTriggerId !=
                  action.data?.uniqueProcessTemplateTaskTriggerId
              );
              item.processTemplateRoundTaskTriggerList = item.processTemplateRoundTaskTriggerList?.filter(
                (x) =>
                  x.uniqueProcessTemplateTaskTriggerId !=
                  action.data?.uniqueProcessTemplateTaskTriggerId
              );
              for (var i of item.processTemplateRoundTaskTriggerList) {
                if (i.uniqueDependentTaskTriggerId) {
                  var isTaskTriggerFound = item.processTemplateRoundTaskTriggerList?.filter(
                    (x) =>
                      x.uniqueProcessTemplateTaskTriggerId ==
                      i.uniqueDependentTaskTriggerId
                  );
                  if (!(isTaskTriggerFound?.length > 0)) {
                    item.processTemplateRoundTaskTriggerList = item.processTemplateRoundTaskTriggerList?.filter(
                      (x) =>
                        x.uniqueProcessTemplateTaskTriggerId !=
                        i.uniqueProcessTemplateTaskTriggerId
                    );
                    if (i.eaProcessTemplateRoundTaskTriggerId) {
                      newState.deletedTaskTriggerIds.push(
                        i.eaProcessTemplateRoundTaskTriggerId
                      );
                    }
                  }
                }
              }
            }
          }
        }
      }
      return newState;
    case FILTER_ASSIGNED_TO_USER_TYPES_BY_WORKFLOW:
      return {
        ...state,
        assignedToUserTypeList: action.assignedToUserTypeList,
      };
    case SET_TRIGGER_AS_UPDATED_AFTER_TRASFER:
      return {
        ...state,
        updatedTaskTriggers: [
          ...state.updatedTaskTriggers,
          state.taskFormData.uniqueProcessTemplateTaskTriggerId,
        ],
        taskFormData: {
          ...state.taskFormData,
          taskTemplateUpdatedBy: "",
        },
      };
    case UPDATE_PROCESS_TEPLATE_ROUND_TASK:
      newState = cloneDeepWith(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        var selectedSequenceNumber =
          action.data?.processRoundData?.eaProcessTemplateRoundId;
        var updatedTaskTriggerData = action.data.taskData;
        if (updatedTaskTriggerData) {
          for (var item of newState.processTemplateRoundList) {
            if (
              item.sequenceNo == selectedSequenceNumber ||
              item.eaProcessTemplateRoundId == selectedSequenceNumber
            ) {
              for (var task of item.processTemplateRoundTaskTriggerList) {
                if (
                  task.uniqueProcessTemplateTaskTriggerId ==
                  updatedTaskTriggerData?.uniqueProcessTemplateTaskTriggerId
                ) {
                  item.processTemplateRoundTaskTriggerList = item.processTemplateRoundTaskTriggerList?.filter(
                    (x) =>
                      x.uniqueProcessTemplateTaskTriggerId !=
                      task.uniqueProcessTemplateTaskTriggerId
                  );
                  if (updatedTaskTriggerData.triggerType == "PTSC") {
                    var previousTaskSelected = item.processTemplateRoundTaskTriggerList?.filter(
                      (x) =>
                        x.uniqueProcessTemplateTaskTriggerId ==
                        updatedTaskTriggerData.uniqueDependentTaskTriggerId
                    );
                    updatedTaskTriggerData.dependentTaskTriggerId =
                      previousTaskSelected[0]?.eaProcessTemplateRoundTaskTriggerId;
                  }
                  updatedTaskTriggerData.uniqueProcessTemplateTaskTriggerId =
                    task.uniqueProcessTemplateTaskTriggerId;
                  updatedTaskTriggerData.eaProcessTemplateRoundTaskTriggerId =
                    task.eaProcessTemplateRoundTaskTriggerId;
                  updatedTaskTriggerData.level = task.level;
                  updatedTaskTriggerData.sequenceNo = task.sequenceNo;
                  updatedTaskTriggerData.eaProcessTemplateRoundId =
                    task.eaProcessTemplateRoundId;
                  item.processTemplateRoundTaskTriggerList.push(
                    updatedTaskTriggerData
                  );
                  break;
                }
              }
              //we need update uniqueProcessTemplateTaskTriggerId for all cards
              //as devexpress diagram requires a new identififer if UI data is updated
              for (var task of item.processTemplateRoundTaskTriggerList) {
                var oldtaskId = task.uniqueProcessTemplateTaskTriggerId;
                var newtaskId = new Guid().toString();
                task.uniqueProcessTemplateTaskTriggerId = newtaskId;
                for (var task of item.processTemplateRoundTaskTriggerList) {
                  if (task.uniqueDependentTaskTriggerId === oldtaskId) {
                    task.uniqueDependentTaskTriggerId = newtaskId;
                    const triggerToUpdate = JSON.parse(task.triggerValue);
                    triggerToUpdate.uniqueProcessTemplateTaskTriggerId = newtaskId;
                    task.triggerValue = JSON.stringify(triggerToUpdate);
                  }
                }
              }
              break;
            }
          }
        }
      }
      return newState;
    case SET_REMIT_SELECTION:
      if (action.data) {
        const isRemitEnabled = action.data.isRemitEnabled;
        if (isRemitEnabled) {
          if (!state.processTemplateFormData?.processTemplateCaseAlertsAssociation.isAtRiskPayerEnabled &&
            !state.processTemplateFormData?.processTemplateCaseAlertsAssociation.isRemitAllPayersEnabled) {
            action.data.isRemitAllPayersEnabled = true;
          }
        }
        else if (isRemitEnabled === false) {
          action.data.isRemitAllPayersEnabled = false;
          action.data.isAtRiskPayerEnabled = false;
        }
        if (action.data.isAtRiskPayerEnabled || action.data.isRemitAllPayersEnabled) {
          action.data.isRemitEnabled = true;
        }
        const updatedState = {
          ...state,
          processTemplateFormData: {
            ...state.processTemplateFormData,
            processTemplateCaseAlertsAssociation: {
              ...state.processTemplateFormData?.processTemplateCaseAlertsAssociation,
              ...action.data,
            },
          },
        };
        return updatedState;
      }
      return state;
    case REORDER_ROUND_TASK_TRIGGER_LIST:
      return {
        ...state,
        processTemplateFormData: {
          ...state.processTemplateFormData,
          isTaskTriggersReordered: true,
        },
        processTemplateRoundList: state.processTemplateRoundList.map((round) => {
          if (round.sequenceNo === action.data.sequenceNo) {
            return {
              ...round,
              processTemplateRoundTaskTriggerList: action.data.reorderedList,
            };
          }
          return round;
        }),
      };
    case ADD_ROUND_DOCUMENTS:
      return {
        ...state,
        processTemplateRoundList: state.processTemplateRoundList.map((round) => {
          const roundKey = round.eaProcessTemplateRoundId || round.sequenceNo;
          if (roundKey === action.data.eaProcessTemplateRoundId) {
            return {
              ...round,
              processTemplateRoundDocumentList: [
                ...(round.processTemplateRoundDocumentList ?? []),
                action.data.pendingDocument,
              ],
            };
          }
          return round;
        }),
      };
    case REMOVE_ROUND_DOCUMENT: {
      const roundForRemove = state.processTemplateRoundList.find(
        (r) => (r.eaProcessTemplateRoundId || r.sequenceNo) === action.data.eaProcessTemplateRoundId
      );
      const docToRemove = roundForRemove?.processTemplateRoundDocumentList?.find(
        (d) => d.eaProcessTemplateRoundDocumentAssociationId === action.data.eaProcessTemplateRoundDocumentAssociationId
      );
      const isPersisted = docToRemove && docToRemove.eaProcessTemplateRoundDocumentAssociationId > 0;
      return {
        ...state,
        deletedRoundDocumentIds: isPersisted
          ? [...(state.deletedRoundDocumentIds ?? []), action.data.eaProcessTemplateRoundDocumentAssociationId]
          : (state.deletedRoundDocumentIds ?? []),
        processTemplateRoundList: state.processTemplateRoundList.map((round) => {
          if ((round.eaProcessTemplateRoundId || round.sequenceNo) === action.data.eaProcessTemplateRoundId) {
            return {
              ...round,
              processTemplateRoundDocumentList: round.processTemplateRoundDocumentList.filter(
                (doc) => doc.eaProcessTemplateRoundDocumentAssociationId !== action.data.eaProcessTemplateRoundDocumentAssociationId
              ),
            };
          }
          return round;
        }),
      };
    }
    case UPDATE_ROUND_DOCUMENT:
      return {
        ...state,
        processTemplateRoundList: state.processTemplateRoundList.map((round) => {
          if (round.eaProcessTemplateRoundId === action.data.eaProcessTemplateRoundId) {
            return {
              ...round,
              processTemplateRoundDocumentList: round.processTemplateRoundDocumentList.map(
                (doc) =>
                  doc.eaProcessTemplateRoundDocumentAssociationId === action.data.eaProcessTemplateRoundDocumentAssociationId
                    ? {
                        ...doc,
                        documentName: action.data.documentName,
                        documentCategoryId: action.data.documentCategoryId,
                        documentCategoryName: action.data.documentCategoryName,
                        attachedLevelName: action.data.attachedLevelName,
                        attachedLevelDisplayName: action.data.attachedLevelDisplayName,
                      }
                    : doc
              ),
            };
          }
          return round;
        }),
      };
    case TRACK_EDITED_ROUND_DOCUMENT: {
      const existing = (state.editedRoundDocuments ?? []).filter(
        (d) => d.eaProcessTemplateRoundDocumentAssociationId !== action.data.eaProcessTemplateRoundDocumentAssociationId
      );
      return {
        ...state,
        editedRoundDocuments: [
          ...existing,
          {
            eaProcessTemplateRoundDocumentAssociationId: action.data.eaProcessTemplateRoundDocumentAssociationId,
            documentName: action.data.documentName,
            documentCategoryId: action.data.documentCategoryId,
            attachedLevelName: action.data.attachedLevelName,
          },
        ],
      };
    }
    default:
      return state;
  }
};

export const formatProcessTemplateObjectToDisplay = (
  data,
  auditGroupDataSourceIds,
  originalRefTaskList,
  taskCategoryTypeList
) => {
  if (!data) return {};
  data.selectedAuditGroupIds = data.auditGroupAssociationList?.map(
    (x) => x.auditGroupId
  );
  if (data.selectedAuditGroupIds?.length <= 0) {
    data.selectedAuditGroupIds = auditGroupDataSourceIds;
  }
  data.selectedRequiredFieldIds = data.requiredFieldAssociationList?.map(
    (x) => x.eaRequiredFieldId
  );
  data.selectedRequiredCaseFieldIds = data.requiredCaseFieldAssociationList?.map(
    (x) => x.eaRequiredCaseFieldId
  );
  var roundListLen = data.processTemplateRoundList?.length;
  if (roundListLen > 0) {
    for (var round of data.processTemplateRoundList) {
      if (!round.processTemplateRoundDocumentList) {
        round.processTemplateRoundDocumentList = [];
      }
      var taskTrigerListLen = round.processTemplateRoundTaskTriggerList?.length;
      if (!(taskTrigerListLen > 0)) {
        continue;
      }
      for (var item of round.processTemplateRoundTaskTriggerList) {
        var templateSelected = originalRefTaskList?.filter(
          (x) => x.refTaskId == item.refTaskId
        )[0];
        var categoryType = taskCategoryTypeList?.filter(
          (x) => x.value == templateSelected?.taskCategoryTypeValue
        );

        item.level = templateSelected?.levelValue == "EA" ? "Audit" : "Case";
        item.requiredForAuditCompletionInd =
          templateSelected?.requiredForAuditCompletionInd;
        item.templateDescription = templateSelected?.description;
        item.dueInDays = templateSelected?.dueAfter
          ? templateSelected?.dueAfter + " " + templateSelected?.dueInterval
          : "";
        item.taskCategoryName = templateSelected?.taskCategoryName;
        item.taskCategoryType = categoryType[0]?.displayName;
        item.refTaskName = templateSelected?.displayName
          ? templateSelected?.displayName
          : templateSelected?.name;
      }
    }
  }
  return data;
};
export const formatProcessTemplateObjectToSave = (
  data,
  auditGroupDataSourceList,
  requiredFieldList,
  processTemplateRoundList,
  hasAllAuditGroupAccess
) => {
  var len = processTemplateRoundList.length;
  if (len > 0) {
    for (var i = 0; i < len; i++) {
      delete processTemplateRoundList[i].isTextBoxWidgetVisible;
    }
  }
  data.processTemplateRoundList = processTemplateRoundList;
  delete data.updateDate;
  const auditGroupIdList = auditGroupDataSourceList.map((x) => x.auditGroupId);
  if (
    data.selectedAuditGroupIds?.length === auditGroupIdList?.length &&
    isEqual(
      data.selectedAuditGroupIds.slice(0).sort(),
      auditGroupIdList.slice(0).sort()
    ) &&
    hasAllAuditGroupAccess
  ) {
    data.selectedAuditGroupIds = null;
  }
  if (data.termDate)
    data.termDate = format(new Date(data.termDate), "MM/DD/YYYY");
  return data;
};
export const formatProcessTemplateRoundList = (
  processTemplateRoundItems,
  data
) => {
  if (processTemplateRoundItems?.length > 0) {
    var count = 0;
    for (var item of processTemplateRoundItems) {
      if (item.isTextBoxWidgetVisible) {
        count = count + 1;
      }
    }
    for (var item of processTemplateRoundItems) {
      if (item && item.sequenceNo == data.sequenceNo) {
        if (!(count > 0) || !data.isTextBoxWidgetVisible) {
          item.eaProcessTemplateRoundName = data.eaProcessTemplateRoundName;
          item.isTextBoxWidgetVisible = data.isTextBoxWidgetVisible;
          item.totalDays = data.totalDays;
          item.requesterId = data.requesterId;
          item.eaContentTypeId = data.eaContentTypeId;
          item.isEsmdRequester = data.isEsmdRequester;
          item.isContentTypeValid = data.isContentTypeValid;
          item.isRequesterReviewContractorValid =
            data.isRequesterReviewContractorValid;
        }
      } else if (!data.isTextBoxWidgetVisible) {
        item.isTextBoxWidgetVisible = false;
      }
    }
  }
  return processTemplateRoundItems;
};
export const formatProcessRoundTaskObjectToSave = (
  data,
  roundItem,
  templateSelected
) => {
  var refTaskItem = templateSelected[0];
  var SequenceNo = 0;
  for (var item of roundItem.processTemplateRoundTaskTriggerList) {
    SequenceNo = item.sequenceNo + 1;
  }
  var requiredTaskData = [
    {
      level: data.level == "EA" ? "Audit" : "Case",
      eaProcessTemplateRoundId: roundItem.sequenceNo,
      refTaskId: data.refTaskId,
      sequenceNo: SequenceNo,
      dependentTaskTriggerId: data?.previousTaskStatusId,
      triggerValue: data.status,
      triggerType: data.triggerType,
      requiredForAuditCompletionInd: refTaskItem.requiredForAuditCompletionInd,
      templateDescription: refTaskItem.description,
      dueAfter: data.dueAfter,
      dueInterval: data.dueInterval,
      dueInDays: data.dueAfter ? data.dueAfter + " " + data.dueInterval : "",
      taskCategoryName: refTaskItem.taskCategoryName,
      assignedToUserType: data.assignedToUserType,
      assignedToUserId: data.assignedToUserId,
      taskCategoryType: data.categoryType[0].displayName,
      refTaskName: refTaskItem.displayName
        ? refTaskItem.displayName
        : refTaskItem.name,
      uniqueProcessTemplateTaskTriggerId: "",
      uniqueDependentTaskTriggerId: "",
      taskTemplateUpdatedBy: data.taskTemplateUpdatedBy,
    },
  ];
  return requiredTaskData[0];
};
export const formatProcessTemplateTaskTriggerToDisplay = (
  currentSelectedTaskTriggerData,
  processTemplateRoundList
) => {
  var data = currentSelectedTaskTriggerData;
  var triggerValue;
  var taskFormData = {
    level: "All",
    refTaskId: data.refTaskId,
    triggerId: data.triggerType,
    previousRefTaskId: null,
    previousTaskStatusId: null,
    caseStatusId: null,
    caseOutcomeIds: null,
    auditStatusId: null,
    dueAfter: data.currentSelectedRoundData?.dueAfter,
    dueInterval: data.currentSelectedRoundData?.dueInterval,
    assignedToUserType: data.currentSelectedRoundData?.assignedToUserType,
    assignedToUserId: data.currentSelectedRoundData?.assignedToUserId,
    taskTemplateUpdatedBy: data.taskTemplateUpdatedBy,
    uniqueProcessTemplateTaskTriggerId: "",
    levelValue:data.levelName ==='Case'? ATTACHED_LEVEL_NAME.ExternalAuditCase:data.levelName
  };
  if (currentSelectedTaskTriggerData.uniqueProcessTemplateTaskTriggerId) {
    taskFormData.uniqueProcessTemplateTaskTriggerId =
      currentSelectedTaskTriggerData?.uniqueProcessTemplateTaskTriggerId;
  }
  var triggerObj = JSON.parse(data.currentSelectedRoundData.triggerValue);

  switch (data.triggerType) {
    case "CSC":
      taskFormData.caseStatusId = triggerObj["caseStatusId"];
      break;
    case "PTSC":
      for (var item of processTemplateRoundList) {
        if (
          data.currentSelectedRoundData.sequenceNo == item.sequenceNo ||
          data.currentSelectedRoundData.eaProcessTemplateRoundId ==
          item.eaProcessTemplateRoundId ||
          item.sequenceNo ==
          data.currentSelectedRoundData?.eaProcessTemplateRoundId
        ) {
          var previousRefTaskItem = item?.processTemplateRoundTaskTriggerList?.filter(
            (x) =>
              x.uniqueProcessTemplateTaskTriggerId ==
              data.currentSelectedRoundData?.uniqueDependentTaskTriggerId
          );
          if (previousRefTaskItem && previousRefTaskItem.length > 0) {
            break;
          }
        }
      }
      taskFormData.previousTaskStatusId = triggerObj["statusId"];
      taskFormData.previousRefTaskId =
        previousRefTaskItem[0]?.uniqueProcessTemplateTaskTriggerId;
      break;
    case "ASC":
      taskFormData.auditStatusId = triggerObj["auditStatusId"];
      break;
    case "CRO":
    case "PRCRO":
      taskFormData.caseOutcomeIds = triggerObj["caseOutcomeIds"];
      break;
    case "RS":
      triggerValue = null;
      break;
    case "LDD":
      triggerValue = null;
      break;
    default:
      triggerValue = null;
  }
  return taskFormData;
};
const syncProcessTemplateRoundSequenceNumber = (
  processTemplateRounds: any[]
) => {
  //sort by ascending sequence number
  processTemplateRounds.sort((a, b) => a.sequenceNo - b.sequenceNo);
  //update sequence number to match the round number
  processTemplateRounds.forEach((item, index) => {
    item.sequenceNo = index + 1;
  });
};

export const isMdauditTransferApplicable: (data) => boolean = (data) => {
  return data?.updatedBy === MDAUDIT_TRANSFER;
};
